
function Spinner() {
  return (
    <div className="loader-wrapper">
        <span className="loader"><span className="loader-inner"></span></span>
    </div>
  )
}

export default Spinner